var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"color":"info","small":"","label":"","outlined":""}},[_c('v-icon',{attrs:{"color":"info","aria-hidden":"true","small":"","left":""}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_c('span',{staticClass:"info--text"},[_vm._v(" "+_vm._s(_vm.label)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }